import React from 'react'
import { Trash } from 'react-bootstrap-icons'

export default function QBuilderComponentDynamicComponentTableLayoutItemOptions({ onRemove, children }) {
    return <div className='p-2'><div className='text-end'><Trash className='m-2' onClick={() => onRemove()} /></div>{children}</div>
}
